export default __webpack_public_path__ + "static/media/recurring-phone6.8ae469fe.png";